import bell from "images/bell.svg";
import React, {useEffect} from "react";
import {useFlintNotificationContext} from "../notifications/FlintNotificationContext";
import UnreadCommentsComponent from "./UnreadCommentsComponent";
import {useAuthenticationContext} from "@utils/auth/AuthenticationContext";
import {useTranslation} from "react-i18next";


export function CommentNotificationIcon() {
    const {state, handlers} = useCommentNotificationIcon();
    return (
        <div className={"notification-container position-relative"}>
            <img src={bell} alt="notification bell" onClick={handlers.handleBellClicked} className={"cursor-pointer"}/>
            {state.unreadComments.get.length > 0 &&
                <span
                    onClick={handlers.handleBellClicked}
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer">
                {state.unreadComments.get.length}
                    <span className="visually-hidden">unread messages</span>
            </span>}
        </div>
    )
}

function useCommentNotificationIcon() {
    const {rightSidebar} = useFlintNotificationContext();
    const {comments, rootModel} = useAuthenticationContext();
    const {t} = useTranslation();

    useEffect(() => {
        if (comments.get.length === 0)
            rightSidebar.hide();
    }, [comments.get.length]);

    function handleBellClicked() {
        if (!rootModel?.CurrentUserProfile.ShowNewCommentsPopup)
            return;
        if (rightSidebar.get.visible) {
            rightSidebar.hide();
            return;
        }
        rightSidebar.show(<UnreadCommentsComponent/>, t("COMMENTS_HISTORY_Header"));
    }

    return {
        state: {
            unreadComments: {get: comments.get},
        },
        handlers: {
            handleBellClicked,
        }
    }
}